import {Component, HostListener} from '@angular/core';
import {Events, IonicPage, LoadingController, MenuController, NavController, PopoverController} from 'ionic-angular';
// @reference https://github.com/ackerapple/ack-angular-webcam
// Imported here just for type checking. Optional.
import {WebCamComponent} from 'ack-angular-webcam';

import {ProofAfterEndPage} from '../proof-after-end/proof-after-end';

import {AlertProvider} from '../../providers/alert/alert';
import {ProofProvider} from '../../providers/proof/proof';
import {MediaProvider} from '../../providers/media/media';
import {ProofServerProvider} from '../../providers/proof-server/proof-server';
import {DateTimeProvider} from '../../providers/datetime/datetime';

import {ITimer} from '../../interfaces/itimer/itimer';

import {MediaItem} from '../../models/mediaitem';
import {QuestionSituation} from '../../models/questionsituation';
import {ProofAudioProvider} from "../../providers/proof-audio/proof-audio";
import {DomSanitizer} from "@angular/platform-browser";

import {Storage} from '@ionic/storage';

import {isNumber} from 'util';
import * as Config from "../../app/app.config";

import {PopovercomponentPage} from '../popovercomponent/popovercomponent';

import {ProofListPage} from "../proof-list/proof-list";

import {FullscreenProvider} from '../../providers/fullscreen/fullscreen';


/**
 * Generated class for the ProofOnWebPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-proof-on-web',
  templateUrl: 'proof-on-web.html',
})
export class ProofOnWebPage {

  hasWebcam: boolean = true;
  photoWebcam: WebCamComponent;
  answer: string;
  answerDis: string;
  question: any;
  questions: any;
  links: any;
  hasPermitConsult: boolean;
  hasNavigate: boolean;
  questionIdx: number;
  questionsTotal: number;
  questionSeconds: number;
  audioQuestionId: number;
  isOnline: boolean = true;
  isOnlineFinish: boolean = false;
  mensage: boolean = false;
  durationMin: string;
  answerArr: any;
  filesQuestion: any;
  url: string;
  thumbUrl: string;
  hasAnswer: boolean;

  // Timer stuff
  private timeInSeconds: number;
  private timeInSecondsMin: number;
  timer: ITimer;
  timerMin: ITimer;

  private proofFinished: boolean;

  public proofIdPrincipal: number = Config.proofId;

  public proofHasCalculator: number = 0;
  public visibleCalc: number = 0;

  // Audio Record
  isRecording: boolean = false;
  recordedTime;
  blobUrl;

  value: string = '0';
  oldValue: string = '0';

  lastOperator: string = 'x';
  readyForNewInput: boolean = true;
  numberGroups: (string | number)[][] = [
    [7, 8, 9, '/'],
    [4, 5, 6, 'x'],
    [1, 2, 3, '-'],
    ['.', 0, '=', '+']
  ];
  loading: boolean = false;
  isLoading: boolean = true;
  countExitScreen: number = 0;
  setExitScreen: number = 0;
  setTextExitScreen: string = null;

  private fullscreenSubscription: any;
  public isFullscreen: boolean = false;

  constructor(
    private navCtrl: NavController,
    private alertProvider: AlertProvider,
    private mediaProvider: MediaProvider,
    private proofServerProvider: ProofServerProvider,
    private proofProvider: ProofProvider,
    private dateTimeProvider: DateTimeProvider,
    private proofAudioProvider: ProofAudioProvider,
    private sanitizer: DomSanitizer,
    private storage: Storage,
    public popoverCtrl: PopoverController,
    private menu: MenuController,
    private events: Events,
    private loadingCtrl: LoadingController,
    private fullscreenProvider: FullscreenProvider,
  ) {
    let that = this;
    this.filesQuestion = [];
    this.url = null;
    this.thumbUrl = null;
    this.answer = null;
    this.answerDis = null;
    this.audioQuestionId = null;
    this.answerArr = [];

    this.question = proofProvider.getCurrentQuestion();
    this.questionIdx = proofProvider.getCurrentQuestionIdx();
    this.questionsTotal = proofProvider.getQuestionsTotal();
    this.questionSeconds = 0;
    this.lockProof();
    this.links = proofProvider.getProofLinks();
    this.hasPermitConsult = proofProvider.isPermitConsult();
    this.hasNavigate = proofProvider.isNavigate();
    this.questions = proofProvider.getProofQuestions();


    // Timer stuff
    this.timeInSeconds = 0;

    this.timeInSecondsMin = 0;
    this.durationMin = this.proofProvider.getDurationMin();
    let b: string[] = this.durationMin.split(':');
    let seconds_min: number = (+b[0]) * 60 * 60 + (+b[1]) * 60 + (+b[2]);
    that.timeInSecondsMin = seconds_min;

    that.initTimer();
    proofProvider.getDuration().then((duration: any) => {
      that.timeInSeconds = duration;
      that.initTimer();
      that.startTimer();
    });

    this.proofServerProvider.getById(this.proofIdPrincipal).subscribe({
      next: data => {
        try {
          this.proofHasCalculator = data.hasCalculator;
        } catch (e) {
          // Do nothing.
        }
      },
      error: err => {
        console.error('Observer got an error: ' + err);
      },
      complete: (): void => {
        console.log('Observer got a complete notification');
      },
    });

    this.fetchQuestion(0, false);

    this.countExitScreen = 0;
    this.proofServerProvider.fetchLockProofData(this.proofProvider.getIdProof()).subscribe({
      next: data => {
        try {
          this.setExitScreen = data.quantity;
          this.setTextExitScreen = data.text;
        } catch (e) {
          // Do nothing.
        }
      },
      error: err => {
        console.error('Observer got an error: ' + err);
      },
      complete: (): void => {
        console.log('Observer got a complete notification.');
      }
    });

    this.fullscreenSubscription = this.fullscreenProvider.fullscreenStatus$.subscribe((status) => {
      this.isFullscreen = status;
      this.whenExitedFromFullscreen();
    });

    // TODO: Send situation to server automatically

    setTimeout((): void => {
      this.proofServerProvider.screens(this.proofProvider.getId(), localStorage.getItem('exams.screens')).subscribe({
        next: (): void => {
          // Do nothing.
        },
        error: (err: any): void => {
          console.error(err);
        }
      });
    }, 100);
  }

  private whenExitedFromFullscreen(): void {
    if (this.isFullscreen || !this.proofProvider.hasProof() || this.question) {
      return;
    }

    // // TODO: Send situation to server automatically
    //
    // let situation = new QuestionSituation();
    // situation.kind = 'QTS';
    // situation.id = this.question.id;
    // situation.captured = this.dateTimeProvider.getISOString();
    // situation.action = 'EFFS'; // 'ExitedFromFullscreen';
    // this.proofProvider.addSituation(situation);
    //
    // const title: string = 'Atenção';
    // const message: string = 'É obrigatório utilizar a tela cheia para realizar a prova. Caso você saia do modo tela cheia, a prova será bloqueada.';
    // this.alertProvider.doAlert(message, title, () => {
    //   this.fullscreenProvider.requestFullscreen().then((): void => {
    //     // Do nothing.
    //   });
    // });

    // if (this.proofProvider.hasProof()) {
    // TODO: Send situation to server automatically
    //
    // if (!this.proofProvider.isPermitConsult()) {
    let situation = new QuestionSituation();
    situation.kind = 'QTS';
    situation.id = this.question.id;
    situation.captured = this.dateTimeProvider.getISOString();
    situation.action = 'EFTB';
    // this.proofProvider.addSituation(situation);
    this.proofServerProvider.sendSituation(this.proofProvider.getId(), situation);

    this.countExitScreen += 1;

    if (this.countExitScreen == this.setExitScreen) {
      this.alertProvider.doAlert(this.setTextExitScreen, 'Prova Bloqueada', null, 'Entendi');

      this.lockProof();
      this.countExitScreen = 0;
      this.menu.enable(true);
      this.menu.swipeEnable(true);
      this.navCtrl.popTo(this.navCtrl.getByIndex(0)).then(() => {
        this.events.publish('doProofUpdate');
      });
      this.navCtrl.push(ProofListPage);
      this.proofServerProvider.notifyAdminUsers();
    } else {
      const msg: string = 'Você saiu da tela de prova. Conforme o Regulamento do Exame o usuário não pode sair da aba da prova, fazer consultas a terceiros ou a outros materiais, podendo ser reprovado caso insista nessa prática.';
      this.alertProvider.doAlert(msg, 'Atenção', () => {
        this.fullscreenProvider.requestFullscreen().then((): void => {
          // Do nothing.
        });
      });
    }
    // }
    // }
  }

  public setImageQuestion(): void {
    this.url = this.thumbUrl = null;
    this.isLoading = true;

    this.proofProvider.getQuestionFiles().subscribe(files_ => {
      const file = files_.find(file_ => file_.questionId === this.question.questionId);

      if (file) {
        const basePath = Config.baseUrl + '/files/getquestionfileurl/' + this.question.questionId + '/' + file.id + '/';
        this.url = basePath + 'medium_';
        this.thumbUrl = basePath + 'thumb_';
      } else {
        this.isLoading = false;
      }
    });
  }

  onImageLoad() {
    this.isLoading = false;
  }

  presentPopover(myEvent) {
    let popover = this.popoverCtrl.create(PopovercomponentPage);
    popover.present({
      ev: myEvent
    });
  }

  onCamError(err) {
    console.error('Sem webcam', err);

    if (this.hasWebcam) {
      this.hasWebcam = false;
    }
  }

  onCamSuccess() {
  }

  fetchQuestion(index, msg: boolean = false): void {
    this.proofProvider.backQuestions();

    if (index > 0 && msg === false) {
      let message: string = 'Certifique-se de responder todas as questões antes de finalizar sua prova.';

      this.alertProvider.doConfirm(message, (): void => {
        this.fetchAnotherQuestion(index);
      });
    } else {
      this.fetchAnotherQuestion(index);
    }
  }

  private fetchAnotherQuestion(index) {
    const nextQuestion = this.proofProvider.getNavigateQuestion(index);
    console.log('fetchAnotherQuestion [nextQuestion] index --->', index);

    if (!nextQuestion) {
      return;
    }

    this.answer = this.answerDis = null;
    this.question = nextQuestion;

    this.setImageQuestion();

    // Selecionar as questões de acordo com a navegação
    const matchingAnswer = this.answerArr.find(idx => this.question.id == idx[0]);
    if (matchingAnswer) {
      this.question.answered = matchingAnswer[1];
    }

    this.answerDis = (!this.question || this.question.typeOfQuestion === 2 && !this.question.answered)
      ? null : this.question.answers[0]['description'];

    this.answer = (!this.question || this.question.typeOfQuestion === 1 && !this.question.answered)
      ? null : this.question.answered;

    if (this.question.upload === '1') {
      this.alertProvider.doAlert(
        'Caso tenha realizado um calculo extenso ou alguma outra observação que queria compartilhar conosco por fazer parte da questão, favor centralizar a imagem do rascunho realizado em frente a sua câmera e apertar o botão de câmera ao lado. Lembrando que a imagem deve estar focada, então avalie antes de tirar a foto. Ah! Se necessário, pode enviar quantas fotos achar importante.'
      );
    }

    this.questionIdx = this.proofProvider.getCurrentQuestionIdx();
    this.questionsTotal = this.proofProvider.getQuestionsTotal();
    this.questionSeconds = 0;

    this.proofServerProvider.setCurrentQuestion(this.proofProvider.getId(), this.questionIdx, this.timer.secondsRemaining) //
      .subscribe(data => console.log(data));
  }

  doContinue() {
    let message: string = 'Você solicitou o encerramento da sua prova. Por favor, note que caso haja questões não respondidas, elas serão consideradas incorretas e não receberá pontuação por elas.<br /><br />Se você ainda tem questões não respondidas, recomendamos você revise todas elas antes de confirmar o encerramento da prova.<br /><br />Você tem certeza de que deseja encerrar a prova agora?';

    this.alertProvider.doConfirm(message, () => {
      console.log('usuário finalizou a prova');
      this.menu.enable(true);
      this.menu.swipeEnable(true);

      this.proofProvider.setFinished();
      this.fullscreenSubscription.unsubscribe();
      this.alertProvider.doWaiting('Processando...');

      // TODO: Verify if its using Wifi mode and warn if not
      // DONE: Bug when #popTo direct to ProofListPage
      this.navCtrl.popTo(this.navCtrl.getByIndex(0)).then(() => {
        this.events.publish('doProofUpdate');
      });
    });
  }

  doAnswer() {
    let that = this;
    if(!this.question){
      return
    }

    if (this.answer === null && this.answerDis === null) {
      let message = 'Sua pergunta não foi respondida. Deseja continuar sem resposta?';

      this.alertProvider.doConfirm(message, () => {
        that.doAnswerAndFetchNextQuestion();
        that.stopRecording();
      });
    } else {

      if (!this.answerArr.includes(this.answer)) {
        if (this.answerArr.length > 0) {
          this.answerArr.forEach((idx, val) => {

            if (idx[0] === this.question.id) {
              this.answerArr.shift();
            }
          });

        }

        this.answerArr.push([this.question.id, this.answer]);

        // selecionar as questões de acordo com a navegação
        if (this.answerArr.length > 0) {
          let question_select = 0;
          let answer_select = 0;

          for (var prop in this.question) {
            this.answerArr.forEach((idx, val) => {

              if (prop === 'id' && this.question[prop] == idx[0]) {

                question_select = idx[0];
                answer_select = idx[1];

                this.question['answered'] = idx[1];

                for (var item in this.questions) {
                  if (this.questions.id == question_select) {
                    this.questions.answered = answer_select;
                  }
                }
              }
            });
          }
        }
      }

      this.doAnswerAndFetchNextQuestion();
      // TODO: Verificar se removendo este, a gravação é contínua
      that.stopRecording();
    }
  }

  private doAnswerAndFetchNextQuestion() {

    if(!this.question){
      return
    }

    if (this.answer) {
      this.proofServerProvider.sendQuestionAnswer(this.proofProvider.getId(), 'QTA', this.question.id, this.answer)
        .subscribe(data => console.log(data));
    }

    this.proofProvider.addAnswer(this.question.id, this.answer);
    this.takeBackgroundPhoto();
    this.startRecording();

    let nextQuestion = this.proofProvider.getNextQuestion();

    if (nextQuestion !== null) {
      this.answer = null;
      this.question = nextQuestion;
      this.questionIdx = this.proofProvider.getCurrentQuestionIdx();
      this.fetchQuestion(this.questionIdx, true);
      this.questionsTotal = this.proofProvider.getQuestionsTotal();
      this.questionSeconds = 0;
      this.proofServerProvider.setCurrentQuestion(this.proofProvider.getId(), this.questionIdx, this.timer.secondsRemaining)
        .subscribe(data => console.log(data));
    }
  }

  finishProof() {
    let that = this;

    this.pauseTimer();
    this.proofFinished = true;
    if (this.proofFinished) {
      let dataEndProof = this.dateTimeProvider.getISOString();
      this.storage.set('userproof_' + that.proofProvider.getId() + '_atEndProof', dataEndProof);
    }
    this.proofProvider.setFinished();

    this.navCtrl.push(ProofAfterEndPage);
  }

  lockProof() {
    let id = this.proofProvider.getId();
    let note = null;
    if (this.countExitScreen > 0) {
      note = "Saída da Tela"
    }

    this.storage.get('userproof_' + id + '_durationTotal').then((value: any) => {
      if (value) {
        this.proofServerProvider.lock(id, value, note);
      }
    });
  }

  setRemaining() {
    let remaining = this.timer.secondsRemaining;
    this.proofServerProvider.setRemaining(this.proofProvider.getId(), remaining);
  }

  private takeBackgroundPhoto() {
    let that = this;
    if(!this.question){
      return
    }

    if (this.hasWebcam) {
      // Fetch photo from webcam
      this.mediaProvider.takeWebcamPicture(this.photoWebcam, (data: string) => {
        let item = new MediaItem();
        item.kind = 'QT';
        item.questionId = that.question.id;
        item.contentOrPath = data;
        item.captured = this.dateTimeProvider.getISOString();
        // Relative to photo on question
        item.seconds = that.timer.seconds - that.timer.secondsRemaining;
        item.secondsRemaining = that.timer.secondsRemaining;
        //console.log(item);
        that.mediaProvider.addMedia(item);

        // Send it to server
        that.proofServerProvider.sendMedias(that.proofProvider.getId());
      });
    }
  }

  private takeFilePhoto() {
    let that = this;
    if(!this.question){
      return
    }

    if (this.hasWebcam) {
      // Fetch photo from webcam
      this.mediaProvider.takeWebcamPicture(this.photoWebcam, (data: string) => {
        let item = new MediaItem();
        item.kind = 'FT';
        item.questionId = that.question.id;
        item.contentOrPath = data;
        item.captured = this.dateTimeProvider.getISOString();
        // Relative to photo on question
        item.seconds = that.timer.seconds - that.timer.secondsRemaining;
        item.secondsRemaining = that.timer.secondsRemaining;
        //console.log(item);
        that.mediaProvider.addMedia(item);

        // Send it to server
        that.proofServerProvider.sendMedias(that.proofProvider.getId());

        this.alertProvider.doAlert('Imagem capturada e enviada.', 'Informação!');
      });
    }
  }

  private takeBackgroundSound() {
    let that = this;
    if(!this.question){
      return
    }

    if (this.hasWebcam) {
      // Fetch photo from webcam
      this.mediaProvider.takeWebcamPicture(this.photoWebcam, (data: string) => {
        let item = new MediaItem();
        item.kind = 'QT';
        item.questionId = that.question.id;
        item.contentOrPath = data;
        item.captured = this.dateTimeProvider.getISOString();
        // Relative to photo on question
        item.seconds = that.timer.seconds - that.timer.secondsRemaining;
        item.secondsRemaining = that.timer.secondsRemaining;
        //console.log(item);
        that.mediaProvider.addMedia(item);

        // Send it to server
        that.proofServerProvider.sendMedias(that.proofProvider.getId());
      });
    }
  }

  private incrementSecondsAndCouldTakePhoto() {
    this.questionSeconds++;

    if ([2, 7, 17, 35, 60].indexOf(this.questionSeconds) >= 0) {
      this.takeBackgroundPhoto();
      this.setRemaining();
    }
  }

  // Timer stuff
  private initTimer() {
    if (!this.timeInSeconds) {
      this.timeInSeconds = 0;
    }

    this.timer = <ITimer>{
      seconds: this.timeInSeconds,
      runTimer: false,
      hasStarted: false,
      hasFinished: false,
      secondsRemaining: this.timeInSeconds
    };

    this.timer.displayTime = this.getSecondsAsDigitalClock(this.timer.secondsRemaining);

    if (!this.timeInSecondsMin) {
      this.timeInSecondsMin = 0;
    }

    this.timerMin = <ITimer>{
      seconds: this.timeInSecondsMin,
      runTimer: false,
      hasStarted: false,
      hasFinished: false,
      secondsRemaining: this.timeInSecondsMin
    };

    this.timerMin.displayTime = this.getSecondsAsDigitalClock(this.timerMin.secondsRemaining);
  }

  private startTimer() {
    this.timer.hasStarted = true;
    this.timer.runTimer = true;

    this.timerTick();
  }

  private pauseTimer() {
    this.timer.runTimer = false;
  }

  private timerTick() {
    let that = this;

    setTimeout(() => {
      if (!that.timer.runTimer) {
        return;
      }

      that.timer.secondsRemaining--;
      that.proofProvider.setDuration(that.timer.secondsRemaining);
      that.timer.displayTime = that.getSecondsAsDigitalClock(that.timer.secondsRemaining);

      if (that.timerMin.displayTime == '00:00:00') {
        that.timerMin.displayTime = that.getSecondsAsDigitalClock(that.timerMin.secondsRemaining);
      } else {
        that.timerMin.secondsRemaining--;
        that.timerMin.displayTime = that.getSecondsAsDigitalClock(that.timerMin.secondsRemaining);
      }

      let a = this.timer.displayTime.split(':');
      let b = this.proofProvider.getDurationMin().split(':');
      let c = this.timeInSeconds;

      let seconds_spend = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);
      let seconds_min = (+b[0]) * 60 * 60 + (+b[1]) * 60 + (+b[2]);
      let seconds_proorf = c;

      let diff_time = seconds_proorf - seconds_spend;

      if (diff_time < seconds_min && (this.questionIdx + 1) == this.questionsTotal) {
        this.isOnline = false;

        if (!this.mensage) {
          this.alertProvider.doAlert('Favor aguarde, você ainda não atingiu o tempo mínimo de ' + this.proofProvider.getDurationMin() + ' de prova!', 'Atenção');
          this.mensage = true;
        }
      } else {
        this.isOnline = true;
      }

      if (diff_time >= seconds_min) {
        this.isOnlineFinish = true;
      }

      that.incrementSecondsAndCouldTakePhoto();

      if (that.timer.secondsRemaining > 0) {
        that.timerTick();
      } else {
        that.timer.hasFinished = true;
      }
    }, 1000);
  }

  private getSecondsAsDigitalClock(inputSeconds: number) {
    let sec_num = parseInt(inputSeconds.toString(), 10); // don't forget the second param
    let hours = Math.floor(sec_num / 3600);
    let minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    let seconds = sec_num - (hours * 3600) - (minutes * 60);
    let hoursString = '';
    let minutesString = '';
    let secondsString = '';

    hoursString = (hours < 10) ? '0' + hours : hours.toString();
    minutesString = (minutes < 10) ? '0' + minutes : minutes.toString();
    secondsString = (seconds < 10) ? '0' + seconds : seconds.toString();

    return hoursString + ':' + minutesString + ':' + secondsString;
  }

  ionViewDidLoad() {
    this.startRecording();
  }

  @HostListener('window:blur', ['$event'])
  onBlur(event: any): void {
    // if (this.proofProvider.hasProof()) {
    //   // TODO: Send situation to server automatically
    //   if (!this.proofProvider.isPermitConsult()) {
    let situation = new QuestionSituation();
    situation.kind = 'QTS';
    situation.id = this.question.id;
    situation.captured = this.dateTimeProvider.getISOString();
    situation.action = 'EFTB';
    // this.proofProvider.addSituation(situation);
    this.proofServerProvider.sendSituation(this.proofProvider.getId(), situation);

    this.countExitScreen += 1;

    if (this.countExitScreen == this.setExitScreen) {
      this.alertProvider.doAlert(this.setTextExitScreen, 'Prova Bloqueada', null, 'Entendi');

      this.lockProof();
      this.countExitScreen = 0;
      this.menu.enable(true);
      this.menu.swipeEnable(true);
      this.navCtrl.popTo(this.navCtrl.getByIndex(0)).then(() => {
        this.events.publish('doProofUpdate');
      });
      this.navCtrl.push(ProofListPage);
      this.proofServerProvider.notifyAdminUsers();
    } else {
      this.alertProvider.doAlert('Você saiu da tela de prova. Conforme o Regulamento do Exame o usuário não pode sair da aba da prova, fazer consultas a terceiros ou a outros materiais, podendo ser reprovado caso insista nessa prática.', 'Atenção');
    }
    //   }
    // }
  }

  /**
   * Audio Record Section
   */
  public startRecording(): void {
    if (this.isRecording) {
      return;
    }

    if (!this.audioQuestionId) {
      this.audioQuestionId = this.question.id;
    }

    this.isRecording = true;
    this.proofAudioProvider.startRecording();

    setTimeout((): void => {
      this.stopRecording()
    }, 10000);
  }

  public abortRecording(): void {
    if (!this.isRecording) {
      return;
    }

    this.isRecording = false;
    this.proofAudioProvider.abortRecording();
  }

  public stopRecording(): void {
    if (!this.isRecording) {
      return;
    }

    // TODO: Criar um objeto para o áudio da questão o qual é criado em TODA mudança de questão SE não existir,
    // porém só é apagado quando pára a gravação ou aborta a gravação
    //let questionId = this.question.id;
    // TODO:
    // audioQuestionId = this.question.id quando obtém a questão, se estiver preenchido não pode mudar esse valor.
    // Se não estiver preenchido, deve setar o valor do id da questão.
    //   Quando aborta ou pára a gravação, executa o stopRecording do proofAudioProvider com esse valor
    let kind: string = 'QA';
    let note = null;
    let extra = null;
    let captured: string = this.dateTimeProvider.getISOString();
    let seconds: number = this.timer.seconds - this.timer.secondsRemaining;
    let secondsRemaining: number = this.timer.secondsRemaining;
    this.proofAudioProvider.stopRecording(this.audioQuestionId, kind, note, extra, captured, seconds, secondsRemaining);
    this.audioQuestionId = null;
    this.isRecording = false;
  }

  public clearRecordedData(): void {
    this.blobUrl = null;
  }

  public ngOnDestroy(): void {
    this.abortRecording();
  }

  public onButtonPress(symbol): void {
    if (isNumber(symbol) || symbol === '.') {
      if (this.readyForNewInput)
        this.value = '' + symbol;
      else
        this.value += '' + symbol;
      this.readyForNewInput = false;
    } else if (symbol === 'limpar') {
      this.value = '0';
      this.readyForNewInput = true;
    } else if (symbol === '=') {
      if (this.lastOperator === 'x')
        this.value = '' + (parseFloat(this.oldValue) * parseFloat(this.value));
      else if (this.lastOperator === '-')
        this.value = '' + (parseFloat(this.oldValue) - parseFloat(this.value));
      else if (this.lastOperator === '+')
        this.value = '' + (parseFloat(this.oldValue) + parseFloat(this.value));
      else if (this.lastOperator === '/')
        this.value = '' + (parseFloat(this.oldValue) / parseFloat(this.value));
      this.readyForNewInput = true;
    } else { // operator
      this.readyForNewInput = true;
      this.oldValue = this.value;
      this.lastOperator = symbol;
    }
  }

  public minMaxCalculator(): void {
    var el = document.getElementById('btn-min-max');

    if (this.visibleCalc > 0) {
      this.visibleCalc = 0;
    } else {
      this.visibleCalc = 1;
    }
  }

  doUpdate() {
    this.loading = true;
    let loader = this.loadingCtrl.create({
      content: 'Atualizando...',
    });

    loader.present();

    this.proofServerProvider.fetchQuestions(this.proofProvider.getId()).subscribe(proof => {
      this.proofProvider.initiateQuestions(proof);
      console.log('proof.questions initiate--->', proof.questions);
      this.questions = proof.questions;
      this.loading = false;
      loader.dismiss();
    }, (error: any) => {
      loader.dismiss();
      console.log('Não foi possível atualizar a prova.', error);
      this.loading = false;
    });
  }

}




// WEBPACK FOOTER //
// ./src/pages/proof-on-web/proof-on-web.ts